import { BreadcrumbComponent, ClickOutsideDirective, ScrolledByContainerDirective, DebugBarComponent } from '@aston/foundation';
import { FeatureFlagsModule } from '@aston/feature-flags';
import { RouterOutlet } from '@angular/router';
import { ThemesModule } from '@aston/themes';
import { AsyncPipe } from '@angular/common';

import { NotificationsPanelComponent } from '../components/notifications-panel/notifications-panel.component';
import { SidePanelComponent } from '../components/side-panel/side-panel.component';
import { MenuComponent } from '../components/menu/menu.component';

export const SHARED_LAYOUT_COMPONENTS = [
	AsyncPipe,
	BreadcrumbComponent,
	ClickOutsideDirective,
	ScrolledByContainerDirective,
	DebugBarComponent,
	FeatureFlagsModule,
	MenuComponent,
	NotificationsPanelComponent,
	RouterOutlet,
	SidePanelComponent,
	ThemesModule,
]
